export const Profile = {
    imgName: 'profile',
    fullname: 'Parinya Dahmi',
    position: 'Full Stack Developer',
    desc: 'I\'m Full Stack Developer in Bangkok, Thailand.',
    skills: [
        {name: 'Javascript', percent: 80},
        {name: 'HTML5', percent: 90},
        {name: 'CSS3', percent: 90},
        {name: 'jQuery', percent: 85},
        {name: 'PHP', percent: 85},
        {name: 'Python', percent: 70},
        {name: 'MySQL', percent: 85},
    ],
    framework: ['Angular', 'React', 'Vue', 'Wordpress', 'BootStrap', 'Codeigniter', 'Firebase',
        'Nodejs', 'PhantomJs', 'Highcharts', 'Git', 'SVN'],
    social: [
        {
            name: 'facebook',
            url: 'https://www.facebook.com/AlwaysBlues'
        },
        {
            name: 'linkedin',
            url: 'https://www.linkedin.com/in/parinya-dahmi-155a05131/'
        },
        {
            name: 'github',
            url: 'https://github.com/Parinyadahmi'
        },
        {
            name: 'instagram',
            url: 'https://www.instagram.com/alwaysblues'
        },
    ],
};



// WEBPACK FOOTER //
// ./src/app/shared/profile/mock-profile.ts